/*
 *
 * DisableVasPopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 19-May-2025
 */

import DisableVasPopup from './DisableVasPopupContainer'

export default DisableVasPopup
